import apiClient from './apiClient';

const API_URL = '/tipotramites';

// Obtener todos los tipos de trámite
export const getTipoTramites = async () => {
    const response = await apiClient.get(API_URL);
    return response.data;
};

// Obtener un tipo de trámite específico por ID
export const getTipoTramitePorId = async (id) => {
    const response = await apiClient.get(`${API_URL}/${id}`);
    return response.data;
};
